import type { IconSvgObject } from './types';

const RotateCwSquareIcon: IconSvgObject = [
  ["path", { d: "M11.5 5H5.5C4.39543 5 3.5 5.89543 3.5 7V9M3.5 13V20C3.5 21.1046 4.39543 22 5.5 22H18.5C19.6046 22 20.5 21.1046 20.5 20V7C20.5 5.89543 19.6046 5 18.5 5H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 2L12.5 5L9.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RotateCwSquareIcon;
